import React from 'react';
import QRCode from 'qrcode.react';

//MUST BE CLASS BASED FOR REACT-TO-PRINT Module
export default class DashboardSticker extends React.Component {
    render() {
        const { siteId, dashboardId, name } = this.props;
        const dashboardUrl = `${window.origin}/site/${siteId}/dashboard/${dashboardId}`;

        return (
            <div id='sticker' className='sticker-container'>
                <div className='sticker'>
                    <div className='qr-info'>
                        <div className='info-col'>
                            <img src={require('../../../assets/images/ExxonMobil-logo.png')} alt='ExxonMobil' />
                            <div className='label'>Qdash:</div>
                            <strong className='name'>{name}</strong>
                        </div>
                        <div className='qr-col'>
                            <QRCode value={`${dashboardUrl}?qrcode=true`} size={220} />
                        </div>
                    </div>
                    <div className='link-info'>{dashboardUrl}</div>
                </div>
            </div>
        );
    }
}
